export default "__VITE_ASSET__BHQEMpUR__"